import React, { useContext, useEffect } from 'react'
import styled from 'styled-components'

import { Web3Context } from '../hooks/web3'
import { ChainMapping, getNetworkName, getSupportedChain } from '../config'
import { BoldCross } from './catalog/icons/Cross'
import { useDarkMode } from './useDarkMode'

import { createWalletEvent } from 'user-events-segment'
import { getProviderType } from './connection/provider'
import { InjectedWindow } from '../utils/types'

interface Props {
  appChainID: number
  supportedChains: ChainMapping[]
}
declare const window: InjectedWindow

function NetworkBanner({ appChainID, supportedChains }: Props) {
  const web3Context = useContext(Web3Context)
  const pausing = supportedChains.length === 0
  const defaultChain = supportedChains[0] as ChainMapping | undefined
  const defaultConfig = defaultChain && defaultChain.config
  const currentChain = supportedChains.find(
    chain => chain.config.appId === appChainID
  )
  const wrongChain = currentChain === undefined
  const [theme, themeToggler, _] = useDarkMode()

  const switchNetwork = web3Context.switchNetwork

  useEffect(() => {
    if (wrongChain) {
      createWalletEvent().network_warning_displayed(
        getProviderType(),
        getNetworkName(appChainID)
      )

      // TODO: this is not solid
      window.applicationContext.wrongNetwork = true
    } else {
      if (window.applicationContext.wrongNetwork) {
        createWalletEvent().network_warning_removed(getProviderType())
      }
    }
  }, [wrongChain])

  return (
    <>
      {defaultChain && wrongChain && (
        <_NetworkBanner>
          <BoldCross color={theme.notMainChainTextColor} />
          <div style={{ width: '0.25rem' }} />
          <span>
            Swaap is currently only available on{' '}
            {defaultConfig!.chain == 'Mainnet'
              ? `${defaultConfig!.network}`
              : `${defaultConfig!.network} ${defaultConfig!.chain}`}
          </span>
          <span
            onClick={() => {
              switchNetwork(getSupportedChain().appId, defaultChain.config)
              createWalletEvent().network_warning_clicked(
                getProviderType(),
                getNetworkName(appChainID)
              )
            }}
            className="light"
            style={{
              alignSelf: 'center',
              cursor: 'pointer',
              textDecoration: 'underline',
              fontSize: '1.35rem',
              marginLeft: '0.75rem',
            }}
          >
            Click here to switch networks
          </span>
        </_NetworkBanner>
      )}
      {pausing && (
        <_NetworkBanner>
          <span>
            🙅 Application on pause. Please visit the site for updates.
          </span>
        </_NetworkBanner>
      )}
    </>
  )
}

//TODO: bug on display ?
const _NetworkBanner = styled.div`
  color: ${({ theme }) => theme.notMainChainTextColor};
  background-color: ${({ theme }) => theme.notMainChainBackgroundColor};
  align-items: center;
  justify-content: center;
  vertical-align: center;
  display flex;

  font-size: 1.75rem;
  font-weight: bold;
  vertical-align: middle;
  overflow: hidden;
  padding: 1.5rem;
  outline: none;
  text-decoration: none;
  text-align: center;
  border-radius: 0% 0% 2% 2%;

  /* Mobiles */
  @media (max-width: 640px) {
    font-size: 1.25rem;
    padding: 1.4rem;
  }
`
export default NetworkBanner
